import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionFormationEntra.css';

const IntroSectionFormationEntra3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Entra Formation
  const formationStats = [
    {
      value: '22h',
      label: 'Formation intensive',
      translationKey: 'formationEntra.stats.duration',
      labelTranslationKey: 'formationEntra.stats.durationLabel'
    },
    {
      value: '100%',
      label: 'Identités sécurisées',
      translationKey: 'formationEntra.stats.security',
      labelTranslationKey: 'formationEntra.stats.securityLabel'
    },
    {
      value: '3x',
      label: 'Réduction des incidents',
      translationKey: 'formationEntra.stats.incidents',
      labelTranslationKey: 'formationEntra.stats.incidentsLabel'
    },
    {
      value: '∞',
      label: 'Conformité garantie',
      translationKey: 'formationEntra.stats.compliance',
      labelTranslationKey: 'formationEntra.stats.complianceLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-formation-entra">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('formationEntra.stats.title', 'Notre promesse')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Maîtrisez en 22h la gestion des identités que les entreprises recherchent."
        subtitle="Nous avons condensé ce savoir-faire en un programme intensif qui transforme vos équipes en experts de la sécurité des identités et une force d'accélération pour votre entreprise."
        titleTranslationKey="formationEntra.stats.title"
        subtitleTranslationKey="formationEntra.stats.subtitle"
        stats={formationStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionFormationEntra3;
